import { NameLinkObject } from '@components/EntityDrawers/constants/empty-objects';
import {
  CommonKeys,
  CoreFormKeys,
} from '@components/EntityDrawers/constants/keys';
import { ComponentKeys } from '@components/EntityDrawers/drawers/Component/keys';
import { ShapeType } from '@constants/types';
import {
  MaxDescriptionLength,
  NameLinksYup,
  YupLink,
} from '@constants/validation';
import { NameLink } from '@store/services/nodes/types';
import { generateSchema, getDefs, getYups } from '@utils/drawers';
import { withId } from '@utils/helpers';
import * as yup from 'yup';

export type ComponentFormValues = yup.InferType<typeof validationSchema> & {
  [ComponentKeys.AuditFinding]: NameLink[];
  [ComponentKeys.ImplementationGuidance]: string;
};

export const ComponentsFields = [
  ...CoreFormKeys,
  CommonKeys.Description,
  CommonKeys.OperationalStatus,
  CommonKeys.TimelineStartDate,
  CommonKeys.TimelineEndDate,
  CommonKeys.DesignEffectiveness,
  CommonKeys.OperationalEffectiveness,
  CommonKeys.OperationalModel,
  CommonKeys.Partners,
  CommonKeys.Assurance,
  CommonKeys.Coverage,
  CommonKeys.Applicability,
  CommonKeys.IsReported,
] as const;

export const validationSchema = generateSchema<
  ShapeType<typeof ComponentsFields>
>({
  ...getYups(...ComponentsFields),
  [ComponentKeys.AuditFinding]: NameLinksYup(),
  [ComponentKeys.ImplementationGuidance]: YupLink({
    maxLength: MaxDescriptionLength,
  }),
});

export const defaultValues: ComponentFormValues = {
  ...getDefs(...ComponentsFields),
  [ComponentKeys.AuditFinding]: [withId(NameLinkObject)],
  [ComponentKeys.ImplementationGuidance]: '',
};
